import { call } from 'redux-saga/effects';

import { ServiceLocator } from '../../app/ServiceLocator';
import { TelemetryEvents } from '../../common/telemetryEvents/TelemetryEvents';
import { BaseTelemetryEvent, TelemetryService, ValidTelemetryEvent } from '../../ts/services/TelemetryService';
import { HomeApiPerformance } from '../telemetry/HomeTelemetryEvents';
import { ChannelTypes } from '../types/ChannelTypes';

/**
 * Since generator functions only return iterators, this hack takes advantage of closures to store information
 * that would normally be returned by a function.
 */
export interface HomeApiResult {
  contentLength: number;
}

// Default result separated for unit testing
export const ApiPerformanceTimerDefaultResult: HomeApiResult = { contentLength: 0 };

/**
 * Calls an API and sends a telemetry event with the duration of the API in ms.
 * @param apiCall: The function to time
 */
export function* apiPerformanceTimer(apiCall: (result: HomeApiResult) => void, channelType: ChannelTypes, pageViewId: string) {
  const apiStartTime = performance.now();
  const result: HomeApiResult = Object.assign({}, ApiPerformanceTimerDefaultResult);

  yield call(apiCall, result);
  const event = generateApiTelemetryEvent(channelType, apiStartTime, result.contentLength, pageViewId);
  sendTelemetryEvent(event);
}

function generateApiTelemetryEvent(channelType: string, startTime: number, contentLength: number, pageViewId: string): ValidTelemetryEvent<HomeApiPerformance> {
  const durationInMilliSecs = performance.now() - startTime;
  return {
    type: TelemetryEvents.HomeApiPerformance,
    channelType,
    durationInMilliSecs,
    contentLength,
    pageViewId,
  };
}

function sendTelemetryEvent(event: BaseTelemetryEvent) {
  const telemetryService = ServiceLocator.get<TelemetryService>('TelemetryService');
  telemetryService.sendEvent(event);
}
